import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { Box, H2 } from '@bigcommerce/big-design';

function PurchaseOrder() {
  const hiddenFileInput = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
	const [isSelected, setIsSelected] = useState(false);
  const [progress, setProgress] = useState(0); // progess bar
  const [fileReady, setFileReady] = useState(null);
  const [uploadDetails, setUploadDetails] = useState(null);
  const [listening, setListening] = useState(false);
  const [sseData, setSSEData] = useState(null);

  const changeHandler = (e) => {
    console.log(e.target);
    setProgress(0);
    if(e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setIsSelected(true);
      setFileReady(null);
      setUploadDetails(null);
    }
	};

  const handlePOInput = (e) => {
    console.log('handlepoinput');
    hiddenFileInput.current.click()
  }

	const handleSubmission = async () => {
    if(!selectedFile) { alert('Please select a CSV file'); return; }
    const formData = new FormData();
    formData.append('purchaseorder', selectedFile);
    
    await axios.post('/api/orders/purchase-order', formData, {
      onUploadProgress: (ProgressEvent) => {
        let progress = Math.round(ProgressEvent.loaded / ProgressEvent.total * 100) + '%';
        setProgress(progress);
      }
    }).then(resp => {
      console.log(resp.data);
      setFileReady(resp.data);
    }).catch(err => {
      console.log(err.data);
      setFileReady(false);
    });
	};

  const processFile = async () => {
    if(!fileReady) { alert('Please select a CSV file'); return; }
    setUploadDetails(null);
    setFileReady({...fileReady, status: 'progress', text: 'Processing...'});
    axios.post('/api/orders/purchase-order/import', fileReady);
    // await axios.post('/api/orders/purchase-order/import', fileReady).then(resp => {
    //   console.log(resp.data);
    //   setFileReady({...fileReady, status: 'success', text: 'Done!'});
    //   setUploadDetails({ data: resp.data });
    // }).catch(err => {
    //   console.log(err);
    //   setFileReady({...fileReady, status: 'error', text: 'Error'});
    // });
	};

  const reset = () => {
    setSelectedFile(null);
    setIsSelected(null);
    setFileReady(null);
    setUploadDetails(null);
    hiddenFileInput.current.value = null;
  }

  const serverSideEvents = () => {
    console.log('SSE', listening);
    if(!listening) {
      // const sse = new EventSource('https://ds.shub.dev/e/temperatures');
      const sse = new EventSource('/api/orders/events');

      sse.onopen = (e) => { console.log('open', e); }

      sse.onmessage = (e) => { console.log('message', e); setSSEData(JSON.parse(e.data)); }

      sse.addEventListener('finished', (e) => { 
        console.log('finished', e);
        let result = JSON.parse(e.data);
        if(result.type) {
          switch(result.type) {
            case 'order-finished': 
              setFileReady({...fileReady, status: 'success', text: 'Done!'});
              setUploadDetails({ data: result.data });
              setSSEData({ msg: `Created Order ID: ${result.data.response.id}` });
              break;
            default:
              setSSEData(result);
              break;
          }
        }
      });

      sse.onerror = (e) => {
        console.log('sse error', e);
        sse.close();
      }

      sse.onclose = (e) => { 
        console.log('closed connection'); 
        sse.close();
      }

      setListening(true);

      return () => {
        console.log('SSE closed');
        sse.close();
      }
    }
  }
  
  useEffect(() => {
    serverSideEvents();
  }, [listening, sseData]);

  // If CSV header errors
  const fileErrors = () => {
    if(!fileReady.errors || fileReady.errors.length <= 0) {
      return <div>
        <button className="btn-import btn-animate" onClick={processFile} disabled={fileReady.status === 'progress' || fileReady.status === 'success'}>
          {fileReady && fileReady.status ? fileReady.text : 'Start import?'}
        </button>
        {fileReady && fileReady.status === 'success' ? <button className="btn-reset btn-animate" onClick={reset}>Reset</button> : null}
      </div>
    } else {
      return <div>
        <h4>Your CSV file contains some errors, please correct and try uploading again</h4>
        <pre>{JSON.stringify(fileReady.errors, null, 2)}</pre>
      </div>
    }
  }

  return (
    <div>
      <Box padding="medium">
        <div className='container form-po'>
          <H2>Select your CSV file to show details</H2>
          <p><a href="/static/media/po-sample.csv">Download a sample CSV file</a></p>
          <button 
            className="btn-upload btn-animate" 
            onClick={handlePOInput}
            style={{maxWidth:'50%'}}
            >{isSelected ? selectedFile.name : 'Select Purchase Order'}</button>
          <input 
            className="input-po"
            type="file"
            accept=".csv"
            ref={hiddenFileInput}
            name="purchaseorder" 
            style={{display: 'none'}}
            onChange={changeHandler} />

          {isSelected && (
            <div>
              <hr/>
              {/* <p>Filename: {selectedFile.name}</p>
              <p>Filetype: {selectedFile.type}</p> */}
              <p>Size in bytes: {selectedFile.size}</p>
              <p>Last Modified Date: {selectedFile.lastModifiedDate.toLocaleDateString()}</p>

              {!fileReady && (<button className="btn-submit btn-animate" onClick={handleSubmission}>Upload</button>)}
              {progress !== 0 && <div className="progessBar" style={{ width: progress }}>{progress}</div>}
            </div>
          )}

          {fileReady && (
            <div>
              <hr/>
              {fileErrors()}
            </div>
          )}

          {/* If the Server-sent Events are just msg */}
          {sseData && sseData.msg && 
            <div>
              <hr/>
              <div style={{textAlign: 'center'}}><p>{sseData.msg}</p></div>
            </div>
          }

          {fileReady && uploadDetails && (
            <div>
              <hr/>
              <h4>Results</h4>
              <table className="joe-table">
                <thead>
                  <tr>
                    <th width="50%">Request</th>
                    <th width="50%">Response</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="50%"><pre>{JSON.stringify(uploadDetails.data.request, null, 2)}</pre></td>
                    <td width="50%"><pre>{JSON.stringify(uploadDetails.data.response, null, 2)}</pre></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Box>
    </div>
  )
}

export default PurchaseOrder